import React, { useEffect, useState } from "react";
import {
  btnStyle,
  managementInputStyle,
  managementModalStyle,
  StyledModal,
} from "pages/PatientOverview/styles";
import CloseIcon from "@mui/icons-material/Close";
import { MultiSelect } from "components/SportSelect/MultiSelect";

import { Box, Grid, CircularProgress, Button } from "@mui/material";
import { PatientRepository } from "repositories/PatientRepository";
import TeamSelector from "pages/auth/TeamSelector";
type Props = {
  isEnabled: boolean;
  setIsEnabled: any;
  patientId: string;
  patientSports: string[];
  sportsList: string[];
  setCurrentSports: any;
};

export const AssignSportModal = ({
  isEnabled,
  setIsEnabled,
  patientId,
  patientSports = [],
  sportsList,
  setCurrentSports,
}: Props) => {
  const [isError, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [selectedSports, setSelectedSports] = useState(patientSports);

  const onCloseResultModal = () => {
    setIsEnabled(false);
  };

  return (
    <StyledModal
      onClick={(e) => {
        e.stopPropagation();
      }}
      aria-labelledby="unstyled-modal-title"
      aria-describedby="unstyled-modal-description"
      open={isEnabled}
    >
      <Box
        sx={{
          ...managementModalStyle,
          minHeight: `250px`,
          height: "auto",
        }}
      >
        <>
          <Grid container mt={1} mb={1}>
            <Grid item xs={12} sx={{ fontWeight: "700", fontSize: 16 }}>
              {"Select a Sport to Assign to the Athlete"}
            </Grid>
            <MultiSelect
              options={sportsList ?? []}
              selectedOptions={selectedSports}
              onItemSelected={(_: any, value: string) => {
                const sportExists = selectedSports?.find(
                  (selectedValue: string) => selectedValue === value
                );
                if (sportExists) {
                  return setSelectedSports(
                    selectedSports.filter(
                      (selectedValue: string) => selectedValue !== value
                    )
                  );
                } else {
                  setSelectedSports([...selectedSports, value]);
                }
              }}
              paddingTop={0}
              hint={`Sports list`}
              menuTitle={""}
              style={{
                border: "1px",
                height: "34px",
                borderRadius: "10px",
                backgroundColor: "#FFFFFF",
                borderColor: "#E5E5E5",
                fontSize: "14px",
                color: "#5C5D69",
                width: "100%",
                marginTop: "20px",
              }}
              emptyMessage={"Please select sport categories in settings page"}
            />
          </Grid>
          <div
            onClick={() => {}}
            style={{
              display: "flex",
              justifyContent: "flex-end",
              width: "100%",
              marginBottom: "20px",
            }}
          >
            <Button
              title="close"
              color="primary"
              variant="contained"
              style={{ ...btnStyle, marginRight: "10px" }}
              onClick={async (e) => {
                setIsEnabled(false);
              }}
            >
              Close
            </Button>
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <Button
                title="Save teams"
                type="submit"
                color="primary"
                variant="contained"
                style={btnStyle}
                onClick={async (e) => {
                  const patientRepo = PatientRepository.getInstance();
                  try {
                    setLoading(true);

                    await patientRepo.updatePatient(patientId, {
                      sports: selectedSports,
                    });
                    setLoading(false);
                  } catch (error) {
                    setLoading(false);
                  }
                  setIsEnabled(false);
                  setCurrentSports(selectedSports);
                }}
              >
                Assign
              </Button>
            )}
          </div>
        </>
      </Box>
    </StyledModal>
  );
};
